// ----------------------------------------------------------------------
// <copyright file="Izenda.AccountLockoutPolicies.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {

  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var constants = require('logic/data/Izenda.SecurityPoliciesConstant');

  var EventsUtils = require('EventUtils');
  var notifyChange = EventsUtils.notifyChange;
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Panel = require('share/components/controls/Izenda.Panel');
  var Input = require('share/components/controls/Izenda.Input');
  var action = require('modules/Settings/SystemConfiguration/SecurityPolicies/Izenda.SecurityPoliciesDetailAction');
  var Validator = require('share/components/hoc/Izenda.Validator');
  var ValidatableInput = Validator()(require('share/components/controls/Izenda.Input'));

  var Header = connect()(function (props) {
    var localization = props.localization;
    return (
      <div onClick={props.collapseToggle}>
        <i className="icon-toggle-triangle"></i>
        <label className='panel-title'>{localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_ACCOUNT_LOCKOUT_POLICIES')}</label>
      </div>
    );
  });

  var AccountLockoutPolicies = connect(action)(function (props) {
    var header = {
      component: Header
    };

    return (
      <Panel className='u_fullHeight u_noMarginAll'
         header={header}
         collapsible
         expanedOption >

          <GridLayout>
            <FailedLogonAttemptsAllowed            {...props} />
            <FailedSecurityQuestionAttemptsAllowed {...props} />
            <LockoutPeriod                         {...props} />
          </GridLayout>
      </Panel>
    );

  });

  var FailedLogonAttemptsAllowed = connect(action)(function (props) {
    var localization = props.localization;
    var model = props.store.model;
    var field = 'numberFailedLogonAttemptsAllowed';
    var valueField = 'numberOfFailedLogonAllowed';
    return (
      <GridLayout.Row className='u_noMarginAll u_borderBottom izenda-ItemContentHeight'>
        <GridLayout.Col cols='12' className='u_noPaddingAll'>
          <GridLayout.Col cols='4' >
            <label>
              <Input type='checkbox'
                     className='u_marginLeft'
                     checked={model[field]}
                     onChange={notifyChange(props.onChangeValueCheckbox.bind(props, field), EventsUtils.CHECKBOX)}
                     />
              <span className='u_marginLeft'>{localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_FAILED_LOGON_ATTEMPTS_ALLOWED')}</span>
            </label>
          </GridLayout.Col>
          <GridLayout.Col cols='8' >
            <ValidatableInput
                   type='input'
                   containerClassName='u_inline'
                   field={valueField}
                   className='izenda-CustomInput-Position form-control u_inlineBlock'
                   disabled={!model[field]}
                   value={model[valueField]}
                   onBlur={props.onBlurFocusField.bind(props, [valueField])}
                   onChange={notifyChange(props.onChangeRequiredValue.bind(props, valueField, constants.REQUIRED_VALUE_NO_PASSWORD_KEEP), EventsUtils.INPUT)}
                   validations={constants.requiredConstraints(localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_FAILED_LOGON_ATTEMPTS_ALLOWED'))}
                   />
          </GridLayout.Col>
        </GridLayout.Col>
      </GridLayout.Row>
    );
  });

  var FailedSecurityQuestionAttemptsAllowed = connect(action)(function (props) {
    var localization = props.localization;
    var model = props.store.model;
    var field = 'numberFailedSecurityQuestionAttemptsAllowed';
    var valueField = 'numberOfFailedAnswerAllowed';
    return (
      <GridLayout.Row className='u_noMarginAll u_borderBottom izenda-ItemContentHeight'>
        <GridLayout.Col cols='12' className='u_noPaddingAll'>
          <GridLayout.Col cols='4' >
            <label>
              <Input type='checkbox'
                     className='u_marginLeft'
                     checked={model[field]}
                     onChange={notifyChange(props.onChangeValueCheckbox.bind(props, field), EventsUtils.CHECKBOX)}
                     />
              <span className='u_marginLeft'>{localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_FAILED_SECURITY_QUESTION_ATTEMPTS_ALLOWED')}</span>
            </label>
          </GridLayout.Col>
          <GridLayout.Col cols='8' >
            <ValidatableInput
                   type='input'
                   containerClassName='u_inline'
                   className='izenda-CustomInput-Position form-control u_inlineBlock'
                   disabled={!model[field]}
                   value={model[valueField]}
                   field={valueField}
                   onBlur={props.onBlurFocusField.bind(props, [valueField])}
                   onChange={notifyChange(props.onChangeRequiredValue.bind(props, valueField, constants.REQUIRED_VALUE_NO_PASSWORD_KEEP), EventsUtils.INPUT)}
                   validations={constants.requiredConstraints(localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_FAILED_LOGON_ATTEMPTS_ALLOWED'))}
                   />
          </GridLayout.Col>
        </GridLayout.Col>
      </GridLayout.Row>
    );
  });

  var LockoutPeriod = connect(action)(function (props) {
    var localization = props.localization;
    var model = props.store.model;
    var enabled = model.enableLockoutPeriod;

    var field = 'lockoutPeriod';
    var constraint = enabled
      ? constants.requiredConstraints(localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_LOCKOUT_PERIOD'))
      : {};

    return (
      <GridLayout.Row className='u_noMarginAll u_borderBottom izenda-ItemContentHeight'>
        <GridLayout.Col cols='12' className='u_noPaddingAll'>
          <GridLayout.Col cols='4' >
            <span className='izenda-CustomInput-Position'>{localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_LOCKOUT_PERIOD')}</span>
          </GridLayout.Col>
          <GridLayout.Col cols='8' >
            <ValidatableInput
                   type='input'
                   containerClassName='u_inline'
                   className='izenda-CustomInput-Position form-control u_inlineBlock u_marginRight'
                   value={model[field]}
                   field={field}
                   onBlur={props.onBlurFocusField.bind(props, [field])}
                   disabled={!enabled}
                   onChange={notifyChange(model.updateValueByKey.bind(model, field), EventsUtils.INPUT)}
                   validations={constraint}
                   />
            <span>{localization.getText('COMMON_LABEL_MINS')}</span>
          </GridLayout.Col>
        </GridLayout.Col>
      </GridLayout.Row>
    );
  });

  module.exports = AccountLockoutPolicies;
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/SecurityPolicies/AccountLockoutPolicies/Izenda.AccountLockoutPolicies.jsx